<template>
  <v-snackbar
    v-model="snackbar"
    :bottom="y === 'bottom'"
    :left="x === 'left'"
    :multi-line="mode === 'multi-line'"
    :right="x === 'right'"
    :timeout="timeout"
    :top="y === 'top'"
    :vertical="mode === 'vertical'"
    :color="color"
  >
    <div style="text-align: center;width: 100%;">
      {{ text }}
    </div>
    <!-- <v-btn color="pink" flat @click="snackbar = false"> Close </v-btn> -->
  </v-snackbar>
</template>

<script>
import { EventBus } from "@/EventBus";
export default {
  data: () => ({
    snackbar: false,
    y: "top",
    x: null,
    mode: "",
    timeout: 6000,
    color: "",
    text: "",
  }),
  methods: {
    snackbarAlert({ color, text, timeout }) {
      this.snackbar = true;
      this.text = text ? text : "-";
      this.color = color ? color : "";
      this.timeout = timeout ? timeout : 6000;
    },
  },
  mounted() {
    EventBus.$on("snackbarAlert", this.snackbarAlert);
  },
  beforeDestroy() {
    EventBus.$off("snackbarAlert", this.snackbarAlert);
  },
};
</script>

<style></style>
